angular.module('nv.shared.filters', []);
